import { RootState } from '../../../../rootReducer';

export const importCodesSelector = (state: RootState) => state.codeBankModuleReducer.ImportCodesReducer;
